import { Input, OnInit, ViewChild } from '@angular/core';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CdTimerComponent } from 'angular-cd-timer';
import moment from 'moment';
import { AgendaService } from 'src/app/service/agenda.service';
import { FreeFormAgendaService } from 'src/app/service/free-form-agenda.service';
import { environment_msg } from 'src/environments/environment';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.css']
})
export class TimerComponent implements OnInit{
  @ViewChild('basicTimer', { static: true })
  basicTimer!: CdTimerComponent;
  //pause variable
  toggleButton = false
  showPause = true;
  showPlay = false
  @Input() hidePause : any
  @Input() timerArray : any
  @Input() timerId : any
  @Input() userId:any;
  @Input() meetingResponse:any
  
  
  @Input() duration:any;
  timerValue : any
  timerJSON:any;
  @Input() meetingId : any
 
  
  // Agenda Timer properties 
  agendaId!: Number;
  confirmAlertFlag  = "";
  agendaStartFlag:any;
  @Input() agendaFlag:any
  @Input() agendaTimerInSeconds:any
  @Input() agendaTraceId !: Number;
  startTime: any;
  curAgendaId: any;
  resumeAgendaId: any;
  pauseAgendaId: any;
  countVal:any;
  traceId:any;
  agendaUser:any;

 
  pauseTimer(agendaId:number) {
    this.confirmAlertFlag = "";
    this.agendaStartFlag = false;
    this.pauseAgendaId = agendaId
    this.toggleButton = true
    this.showPause = false
    this.showPlay = true
    this.timerJSON.agendaTraceId = this.agendaTraceId;
    this.timerJSON.agendaTimer = document.querySelector('#clock'+agendaId)?.innerHTML;
    this.timerJSON.agendaFlag = "END";
    this.agendaService.updateAgendaTimer(this.timerJSON).subscribe((data: any) => {
    });
    this.freeFormAgendaService.collapAgendaList(this.timerJSON,'pause');
  }

  resumeTimer(agendaId:number) {
    this.agendaStartFlag = true;
    this.resumeAgendaId = agendaId;
    this.toggleButton = false
    this.showPlay = false;
    this.showPause = true;
    if(this.timerArray.length != 0){
      for(var i  = 0; i < this.timerArray.length; i ++ ){
        let pauseTimer = document.getElementById('pauseTimer'+this.timerArray[i]);
        let playTimer = document.getElementById('playTimer'+this.timerArray[i]);
        if(pauseTimer != null){
          // window.alert("pause arrow triggered")
          pauseTimer.click();
        }
        this.timerJSON.agendaTraceId = this.agendaTraceId;
        this.timerJSON.agendaTimer = document.querySelector('#clock'+agendaId)?.innerHTML;
        this.timerJSON.agendaFlag = "START";
        this.agendaService.updateAgendaTimer(this.timerJSON).subscribe((data: any) => {
        });
      }
      // this.timerTrackerArray.map((e : any , index : any) => {
        
        // let pauseTimer = document.getElementById('pauseTimer'+e);
        // let playTimer = document.getElementById('playTimer'+e);
        
      // })
    }
    this.freeFormAgendaService.collapAgendaList(this.timerJSON,'resume');
  }

  clockStarts(e : any){
    

  }

  ngDoCheck(){
    
    
    if(this.agendaStartFlag != false && this.agendaStartFlag != null && this.agendaStartFlag != undefined && this.confirmAlertFlag != "N"){

      this.countVal = this.basicTimer.get().minutes;
      
      
      if(this.duration!=0 && this.duration == this.countVal){
        
        let pauseTimer = document.getElementById('pauseTimer'+this.timerId);
        
        if(pauseTimer!=null){
        pauseTimer.click();
        // confirmAlertFlag = "Y";
        if(this.confirmAlertFlag != "N"){
        this.dialog.open(ConfirmDialogComponent, {
          
          data: {
            dialogTitle : "Confirmation",
            dialogContent : environment_msg.msg_confirm_extend_agendaTime
          },
        }).afterClosed().subscribe(response => {
          if(response == true && this.confirmAlertFlag != "N"){  
            this.confirmAlertFlag = "Y";
          }
          else{
            this.confirmAlertFlag = "N";
          }
          var agendaTimerExtend
          agendaTimerExtend =response
          if(agendaTimerExtend && this.confirmAlertFlag == "Y"){
            this.confirmAlertFlag = "N";
            let playTimer = document.getElementById('playTimer'+this.timerId);
            playTimer?.click();

          }
        })
        
      }
    }
    }
    }
    
    // if(this.agendaSecId == "agTimer" && this.timerId == this.curAgendaId && (this.curAgendaId != this.pauseAgendaId || this.resumeAgendaId == this.pauseAgendaId)){
    //   
    
    // }
    
  }

  constructor(private agendaService:AgendaService,private dialog : MatDialog,private freeFormAgendaService:FreeFormAgendaService) { 
    
    this.agendaUser=localStorage.getItem('userId')
  }
  ngOnInit(): void {
    this.agendaId = this.timerId;
    // this.timer.start()
    if(this.agendaFlag=="START"){
      this.agendaStartFlag=true;
    }
    if(this.agendaTimerInSeconds !=null){
      $('timer'+this.agendaId).attr('hidden','false')
    }
    this.timerJSON = { 
      "agendaId":this.agendaId,
      "meetingId":this.meetingId,
    }
  }

  startInitTimer(agendaId:number){  
    if(this.meetingResponse.meetingEndFlag == 'Y'){
      document.getElementById('pauseTimer'+agendaId)?.click();

    }  
    else{
      this.basicTimer.start();
      var val=document.getElementById('startTimer'+agendaId)?.innerHTML;
    this.agendaStartFlag = true;
    this.curAgendaId = agendaId;
      this.timerJSON.agendaTimer = document.querySelector('#clock'+agendaId)?.innerHTML;
    this.timerJSON.agendaFlag = "START";
    this.timerJSON.agendaTraceId = this.agendaTraceId;
    if((this.agendaTraceId!=null && this.agendaTraceId!=undefined)|| val!="Start"){
      this.agendaService.updateAgendaTimer(this.timerJSON).subscribe((data: any) => {
      });
    }else{
      this.agendaService.saveAgendaTimer(this.timerJSON).subscribe((data: any) => {
        this.agendaTraceId = data['agendaTraceId'];
       //this.freeFormAgendaService.collapAgendaList(data,'start');
        //this.meetingResponse.agendaList.forEach()
        this.meetingResponse.agendaList.forEach((agElem: any, agIndex: any) => {
          if(agElem.agendaId == agendaId){
            agElem.agendaTraceId = this.agendaTraceId;
            agElem.agendaFlag = data['agendaFlag'];
          }
        });
      });  
    }
    }

  }
  ngOnDestroy(){

  }
  

}

